import { Action, ActionType } from "@redux/actionTypes/revenueActionTypes";
import { Reducer } from "react";

export interface IRevenueState {
  revenueGCDetailsByPID: IRevenueGCDetailsByPID[];
}

export interface IRevenueGCDetailsByPID {
  projectId: number;
  projectName: string;
  financialAssumptions: IfinancialAssumptions;
  businessUnits: IBusinessUnitData;
}

interface IfinancialAssumptions {
  headers?: Iheaders[];
  tableData: Record<string, any>[];
}

interface IBusinessUnitData {
  businessUnitData: Record<string, any>[];
}

export interface Iheaders {
  headName: string;
  value: string;
  classname?: string;
}

const initialState = {
  revenueGCDetailsByPID: [],
};

export const revenueReducer: Reducer<IRevenueState, Action> = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.REVENUE_GC_DETAILS_BY_PID:
      return {
        ...state,
        revenueGCDetailsByPID: action.payload,
      };
    case ActionType.RESET_REDUX_STATE: {
      return initialState;
    }
    default:
      return state;
  }
};
